module.exports = __webpack_public_path__ + "img/no_order.e6bd9d31.svg";